// CSV column names match the actual file format: EASTING,NORTHING,ELEVATION,LOCATION,POS
// LOCATION column = grade name used when calling the API
export const BOUNDARY_HEADERS = {
  LOCATION: 'LOCATION',
  POS: 'POS',
  EASTING: 'EASTING',
  NORTHING: 'NORTHING',
  ELEVATION: 'ELEVATION',
} as const;

export type BoundaryHeaderKey = keyof typeof BOUNDARY_HEADERS;

export const BOUNDARY_HEADER_LABELS: Record<BoundaryHeaderKey, string> = {
  LOCATION: 'Location (Grade Name)',
  POS: 'Pos',
  EASTING: 'Easting',
  NORTHING: 'Northing',
  ELEVATION: 'Elevation (m)',
};

export const REQUIRED_HEADERS: BoundaryHeaderKey[] = [
  'LOCATION',
  'POS',
  'EASTING',
  'NORTHING',
  'ELEVATION',
];

export const TEMPLATE_SAMPLE_ROW: Record<BoundaryHeaderKey, string> = {
  LOCATION: '4320885LG-B1',
  POS: '1',
  EASTING: '422732.003',
  NORTHING: '5204606.375',
  ELEVATION: '320.000',
};

export const validateHeaders = (
  fileHeaders: string[]
): { valid: boolean; missing: string[] } => {
  const normalised = fileHeaders.map((h) => h.trim().toUpperCase());
  const missing = REQUIRED_HEADERS.filter((h) => !normalised.includes(h));
  return { valid: missing.length === 0, missing };
};
